import React from 'react'
import tw, { styled }  from 'twin.macro'
//import styled from 'styled-components'
//import breakpoint from 'styled-components-breakpoint'
import { Link } from 'gatsby'
import { DrupalLink } from '../../utils/drupal';
import Pill from '@ui-kit/atoms/button/pill'
//import { responsiveColor } from '@ui-kit/helpers'
import Prose from '@ui-kit/atoms/prose';

import { GatsbyImage, getImage, withArtDirection, IArtDirectedImage } from "gatsby-plugin-image"

import Award from '../award'

import './styles.css'

const TwoCol = ({ pid, heading, reversed, body, links, r: { terms, image, tint }, site = process.env.GATSBY_SITE, wysiwygFiles, ...props }) => {

    let images: IArtDirectedImage | null = null;
    let orientation = 'portrait';
    if(image) {
        orientation = image.meta.height > image.meta.width ? 'portrait' : 'landscape';

        images = withArtDirection(getImage(image.r.image?.file?.sharp?.lg), orientation === 'portrait' ? [
            {
                media: "(max-width: 768px)",
                image: getImage(image.r.image?.file?.sharp?.sm),
            },
        ] : [])
    }

    let tint_class = '';
    if (tint) {
        tint_class = `is-tinted tint--${tint.name}`
    }

    return (
        <Style data-reversed={reversed} orientation={orientation} className={`promotion promotion--two-col ${tint_class}`}>
            <div className="max-w-7xl mx-auto px-4 lg:px-10 mg:px-16 grid md:grid-cols-2 gap-y-8 gap-x-10 lg:gap-x-16 xl:gap-x-32">
            <article className={`promotion__article`}>
                <h3>{heading}</h3>
                {body && <Prose element="div" className="prose" wysiwygFiles={wysiwygFiles} env={site} html={body.html} />}

                {links && (
                    <ul className="promotion__links">
                        { links.map((link, i) => (
                            <li key={i}>
                                {link.path ? <Link to={link.path.replace(`/${site}/`, '/')}><Pill elem="span">{link.title}</Pill></Link> : <DrupalLink to={link.uri.replace(`/${site}/`, '/')}><Pill elem="span">{link.title}</Pill></DrupalLink>}
                            </li>
                        ))}
                    </ul>
                )}

                {terms && terms.map((term, i) => (
                        <Award key={i}
                            award={term.award}
                            awardedBy={term.awardedBy}
                            awardYear={term.awardYear}
                            {...term}
                        />
                ))}
            </article>
            { images && (
                <GatsbyImage
                    as="figure"
                    className="promotion__image"
                    image={images}
                    loading="eager"
                    objectFit="contain"
                    alt={heading}
                    />
            )}
            </div>
        </Style>
    )
}




export default TwoCol;
TwoCol.defaultProps = {
    reversed: false,
    r: {
        terms: [],
        image: null
    }
}


const Style = styled.div`
    .promotion__article {

        ul:not([class]) {
            ${tw`listStyle[disc] marginLeft[1.5em]`}
        }

        ol:not([class]) {
            ${tw`listStyle[auto] marginLeft[1.5em]`}
        }

        ol[type="a"] {
            list-style-type: lower-alpha;
        }
        ol[type="i"] {
            list-style-type: lower-roman;
        }

        .align-center {
            ${tw `text-center`}
        }

        .media iframe {
            ${tw `aspectRatio[16/9] align-top max-w-full h-auto shadow-lg`}
        }
    }
`

